import helper from './hotjarHelper'

export default helper
export * from './types'
